

import TextSearchFilter from '@/components/Search/Filtering/TextSearchFilter.vue'
import DateSearchFilter from '@/components/Search/Filtering/DateSearchFilter.vue'
import Button from '@/components/UntitledUI/Button.vue'

export default {
    name: 'SearchFilters',
    components: {
        DateSearchFilter,
        TextSearchFilter,
        Button
    },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        mainTag: {
            type: Object,
            required: true
        },
        tags: {
            type: Array,
            default: () => []
        },
        selectedFilters: {
            type: Object,
            default: () => ({})
        }
    },
    data () {
        return {
            activeFilter: null,
            options: {
                package_results_only: !!(this.$route.query['options[package_results_only]'] ?? false)
            },
            tagForm: new this.$vForm({
                tags: [],
                tag: '',
                offset: 0,
                query: undefined
            })
        }
    },
    computed: {
        hasFilters () {
            return Object.keys(this.selectedFilters.tags ?? {}).length + Object.keys(this.selectedFilters.range ?? {}).length
        }
    },
    methods: {
        applyFilter (tag, values) {
            this.$emit('apply-filters', { tag, values })
        },
        applyOptions () {
            this.$emit('apply-options', this.options)
        },
        toggleValue (value, key) {
            this.options[key] = value

            this.applyOptions()
        }
    }
}
